export const MuiLink = {
  defaultProps: {
    underline: 'hover',
  },
  styleOverrides: {
    root: {
      fontSize: '13px',
      letterSpacing: '0.02em',
      opacity: '0.5',
    },
  },
}
